<template>
  <van-action-sheet
    class="current-action-sheet"
    :class="{ 'current-action-sheet-default' : !msgStyle }"
    v-model="isShow"
    :title="title"
    @close="close"
    :overlay="overlay"
    :duration="duration"
    :closeable="false"
    :style="msgStyle"
  >
    <div class="current-action-sheet-main">
      <div class="current-action-sheet-site">
        <div class="current-action-sheet-msg" v-html="msg" />
      </div>
      <div class="action-sheet-button-site">
        <PopupButton
          class="popup-left popup-smail-button"
          v-if="ok && cancel"
          @click="clickBtn(() => typeof cancel === 'function' && cancel())"
        >
          {{ cancelTxt }}
        </PopupButton>
        <PopupButton
          class="popup-right popup-smail-button"
          buttonType="ok"
          v-if="ok && cancel"
          @click="clickBtn(() => typeof ok === 'function' && ok())"
        >
          {{ okTxt }}
        </PopupButton>
      </div>
    </div>
  </van-action-sheet>
</template>

<script>
import PopupButton from "./popup-button";
import { ActionSheet } from 'vant';

Vue.use(ActionSheet);
export default {
  components: { PopupButton },
  computed: {
    msgStyle() {
      let __style = ``;
      if (this.fontColor) {
        __style += `color: ${this.fontColor} !important;`;
      }
      if (this.backgroundColor) {
        __style += `background-color: ${this.backgroundColor} !important;`;
      }
      return __style;
    }
  },
  data() {
    return {
      overlay: true,
      isShow: false,
      title: "",
      msg: "",
      ok: undefined,
      cancel: undefined,
      okTxt: "",
      cancelTxt: "",
      duration: 0.1,
      fontColor: '',
      backgroundColor: ''
    };
  },
  watch: {
    isShow(val) {
      if (!val) {
        this.$nextTick(() => {
          this.$root.timeout(() => {
            this.overlay = true;
            this.ok = undefined;
            this.cancel = undefined;
            this.msg = undefined;
            this.okTxt = "";
            this.cancelTxt = "";
            this.duration = 0.1;
          }, 500);
        });
      }
    },
  },
  methods: {
    clickBtn(callback) {
      this.isShow = false;
      this.$root.timeout(() => typeof callback === 'function' && callback(), 200);
    },
    close() {
      typeof this.cancel === 'function' && this.cancel();
    },
    showActionSheet(_params = {}) {
      const { isShow, params } = _params;
      this.isShow = !!isShow;
      const {
        overlay = true,
        msg,
        ok,
        cancel,
        okTxt = "ok",
        cancelTxt = "cancel",
        title,
        duration = 0.1,
        fontColor,
        backgroundColor
      } = params;
      this.overlay = overlay;
      this.duration = duration;
      this.msg = msg || "";
      this.title = title || "";
      this.ok = (typeof ok === "function" && ok) || undefined;
      this.cancel = (typeof cancel === "function" && cancel) || undefined;
      this.okTxt = okTxt;
      this.cancelTxt = cancelTxt;
      this.fontColor = fontColor;
      this.backgroundColor = backgroundColor;
    }
  },
  mounted() {
    Vue.filter("current-action-sheet", (isShow, params) => this.showActionSheet({ isShow, params }));
  },
  watch: {
    $route() {
      this.isShow = false
    }
  }
};
</script>
<style lang="stylus">
  .current-action-sheet {
    .van-action-sheet__header {
      padding-top: 10px;
      font-size: 16px;
      font-family: PingFang-SC-Bold, PingFang-SC;
      font-weight: bold;
      line-height: 38px;
    }
  }
  .current-action-sheet-default {
    color: #3A3A3B;
  }
</style>
<style lang="stylus" scoped>
.current-action-sheet {
  width: 100%;
  color: #5D667F;
  font-size: 16px;
}
.current-action-sheet-default {
  .current-action-sheet-msg {
    color: #8D8E90;
  }
}
.current-action-sheet-msg {
  width: 100%;
  font-size: 14px;
  line-height: 20px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  min-height: 100px;
}
.current-action-sheet-site {
  width: 100%;
  padding: 0 15px 8px 15px;
  position: relative;
  box-sizing: border-box;
}
.action-sheet-button-site {
  width: 100%;
  height: 48px;
}
.popup-smail-button {
  width: 50%;
  height: 100%;
  box-sizing: border-box;
}
.popup-smail-button:first-child {
  border-right: 0.5px solid #F5F6F7;
}
.popup-left {
  float: left;
}
.popup-right {
  float: right;
}
</style>
